export interface ArticleBlock {
  type: "p" | "h2" | "quote";
  text: string;
}

export interface Article {
  id: string;
  title: string;
  excerpt: string;
  categorySlug: string;
  categoryName: string;
  author: string;
  date: string;
  readTime: string;
  hot: number;
  tags: string[];
  cover: string;
  content: ArticleBlock[];
}

export const articles: Article[] = [
  {
    id: "summer-echo-finale",
    title: "《盛夏回声》收官夜：三个被反复回看的镜头",
    excerpt:
      "收官夜没有强行煽情，热度最高的反而是三个细节镜头。把它们拆开看，就知道观众到底在回看什么。",
    categorySlug: "variety",
    categoryName: "综艺名场面",
    author: "编辑部 · 阿柚",
    date: "2026-09-08",
    readTime: "4 分钟",
    hot: 9860,
    tags: ["综艺", "收官夜", "名场面"],
    cover:
      "https://readdy.ai/api/search-image?query=warm%20tv%20studio%20stage%20with%20crimson%20backdrop%20and%20amber%20spotlights%2C%20empty%20variety%20show%20set%2C%20cinematic%20editorial%20photography%2C%20clean%20composition&width=800&height=500&seq=art-2026-a1&orientation=landscape",
    content: [
      {
        type: "p",
        text: "收官夜的讨论通常落在『哭没哭』，但这一季的讨论点明显偏向了细节。回看量最高的三段都不是台词，而是镜头与停顿。",
      },
      { type: "h2", text: "一、后台走廊的那次回头" },
      {
        type: "p",
        text: "镜头跟着一位嘉宾走向后台，走到一半她突然回头看了眼空舞台。没有配乐，只有走廊的脚步声。很多观众说，这一下比任何告别词都更像告别。",
      },
      { type: "h2", text: "二、没有台词的三十秒" },
      {
        type: "p",
        text: "公布结果前，剪辑给了整整三十秒的无台词画面，只有呼吸声和纸张翻动。节奏上这是一次冒险，但正是这段留白把悬念拉满。",
      },
      { type: "h2", text: "三、字幕之外的一句即兴" },
      {
        type: "p",
        text: "有句玩笑话没进正片字幕，只在现场音里隐约可闻。它后来成了评论区的高频引用，也说明观众对『没被加工过的瞬间』越来越敏感。",
      },
      {
        type: "quote",
        text: "名场面不一定靠大动作，有时候它只是把镜头多停留了两秒。",
      },
    ],
  },
  {
    id: "fog-harbor-trailer",
    title: "新剧《雾港》预告发布：被讨论最多的是双线叙事",
    excerpt:
      "预告只有 90 秒，却把两条时间线并排剪了出来。观众最在意的是它会不会把节奏拖慢。",
    categorySlug: "screen",
    categoryName: "影视风向",
    author: "编辑部 · 顾南",
    date: "2026-09-07",
    readTime: "5 分钟",
    hot: 9120,
    tags: ["剧集", "预告", "叙事"],
    cover:
      "https://readdy.ai/api/search-image?query=cinema%20hall%20with%20warm%20golden%20light%20and%20crimson%20seats%2C%20empty%20rows%20in%20soft%20focus%2C%20cinematic%20editorial%20photography%2C%20clean%20background&width=800&height=500&seq=art-2026-a2&orientation=landscape",
    content: [
      {
        type: "p",
        text: "预告片放出后，弹幕里出现频率最高的一句是『希望别注水』。原因很直接：90 秒里塞进了两条时间线。",
      },
      { type: "h2", text: "双线并排，考验的是节奏" },
      {
        type: "p",
        text: "剪辑用同一段配乐串起了十年前与现在的画面，观众需要自己把人物对应起来。这种处理能让悬疑感更强，但如果正片不做清晰的时间提示，很容易让人中途走神。",
      },
      { type: "h2", text: "被忽略的那个细节" },
      {
        type: "p",
        text: "预告最后 5 秒的环境音里有一段广播，内容和第一集的开场台词正好对上。这被解读为主创在铺垫循环结构，但目前仍属观众推测。",
      },
      {
        type: "quote",
        text: "好的预告不是把剧情讲完，而是让人愿意为节奏赌一次。",
      },
    ],
  },
  {
    id: "stage-detail-camera",
    title: "舞台直拍为什么更容易出圈：慢镜头的细节红利",
    excerpt:
      "同一段表演，直拍版本的传播量常常超过官方镜头。差别不在画质，而在『看见细节』的效率。",
    categorySlug: "stage",
    categoryName: "舞台现场",
    author: "编辑部 · 小野",
    date: "2026-09-06",
    readTime: "4 分钟",
    hot: 8740,
    tags: ["直拍", "舞台", "镜头"],
    cover:
      "https://readdy.ai/api/search-image?query=concert%20stage%20with%20warm%20spotlights%20and%20haze%2C%20close%20detail%20of%20stage%20floor%2C%20no%20people%2C%20cinematic%20editorial%20photography&width=800&height=500&seq=art-2026-a3&orientation=landscape",
    content: [
      {
        type: "p",
        text: "官方镜头追求全场气势，直拍追求的是『我能不能看清她这一步怎么走的』。两种诉求不同，传播结果自然不同。",
      },
      { type: "h2", text: "固定机位带来的真实感" },
      {
        type: "p",
        text: "直拍通常用固定机位，没有剪辑切换，观众可以完整看到动作的起承转合。当一个转身或落地做得很干净时，这种连贯性会被放大。",
      },
      { type: "h2", text: "慢放之后，瑕疵也会被放大" },
      {
        type: "p",
        text: "直拍的另一面是，任何细节都会被回看。这让舞台表现的门槛变高，也让『稳定的基本功』更容易被看见和讨论。",
      },
      {
        type: "quote",
        text: "观众不是想看完美，而是想看有没有被认真对待。",
      },
    ],
  },
  {
    id: "red-carpet-color",
    title: "红毯配色观察：高饱和与低饱和今年的两股风",
    excerpt:
      "今年红毯明显分成两派：要么极亮，要么极淡。中间地带反而最容易被镜头吃掉。",
    categorySlug: "style",
    categoryName: "红毯造型",
    author: "编辑部 · 苏黎",
    date: "2026-09-05",
    readTime: "3 分钟",
    hot: 7980,
    tags: ["红毯", "造型", "配色"],
    cover:
      "https://readdy.ai/api/search-image?query=red%20carpet%20entrance%20with%20warm%20golden%20lighting%20and%20velvet%20rope%2C%20empty%20red%20carpet%2C%20cinematic%20editorial%20photography%2C%20clean%20background&width=800&height=500&seq=art-2026-a4&orientation=landscape",
    content: [
      {
        type: "p",
        text: "翻完这一季的红毯图，会有一个很直接的感受：颜色要么大声，要么安静，中间调变得少见。",
      },
      { type: "h2", text: "高饱和：赢在远距离识别" },
      {
        type: "p",
        text: "纯色高饱和的造型在广角镜头里最容易跳出来，一张缩略图就能被认出来。缺点是对灯光和肤色的要求更高。",
      },
      { type: "h2", text: "低饱和：赢在近景质感" },
      {
        type: "p",
        text: "米白、燕麦、灰褐这类低饱和色，在近景特写里更耐看，面料肌理也更清楚。它们不抢眼，但经得起放大。",
      },
      { type: "h2", text: "配饰是分水岭" },
      {
        type: "p",
        text: "同一件礼服，换一套配饰气质就完全不同。今年的趋势是把配饰做减法，只留一处视觉重心，反而更显干净。",
      },
    ],
  },
  {
    id: "old-songs-return",
    title: "夏日歌单回潮：三首老歌为什么又冲回榜单",
    excerpt:
      "没有新发行，也没有大型宣传，三首几年前的歌却重新出现在热榜里。原因藏在短视频的二次使用里。",
    categorySlug: "music",
    categoryName: "音乐热歌",
    author: "编辑部 · 林声",
    date: "2026-09-04",
    readTime: "4 分钟",
    hot: 7350,
    tags: ["音乐", "歌单", "回潮"],
    cover:
      "https://readdy.ai/api/search-image?query=vintage%20vinyl%20record%20player%20on%20warm%20wooden%20desk%20with%20amber%20light%2C%20cinematic%20editorial%20still%20life%2C%20clean%20simple%20background&width=800&height=500&seq=art-2026-a5&orientation=landscape",
    content: [
      {
        type: "p",
        text: "歌单回潮有个共同规律：先被短视频当成背景音使用，再被完整收听，最后进入日常歌单。",
      },
      { type: "h2", text: "副歌前置的力量" },
      {
        type: "p",
        text: "这三首歌的结构都很『好用』——副歌直接进，情绪单一，很适合 15 秒的片段。创作者使用成本低，传播自然快。",
      },
      { type: "h2", text: "为什么是它们，而不是更新的歌" },
      {
        type: "p",
        text: "老歌有一个优势：没有发行期的宣传疲劳。当它再次出现时，观众感受到的是熟悉而不是打扰，接受度更高。",
      },
      {
        type: "quote",
        text: "歌曲的第二次生命，往往不是靠重发，而是靠被重新使用。",
      },
    ],
  },
  {
    id: "meme-archaeology",
    title: "热梗考古：一句台词如何变成全网通用语",
    excerpt:
      "一个梗的生命周期通常是三周。搞清楚它从哪来、怎么扩散，也就明白它为什么会突然消失。",
    categorySlug: "meme",
    categoryName: "网络热梗",
    author: "编辑部 · 白桃",
    date: "2026-09-03",
    readTime: "5 分钟",
    hot: 6890,
    tags: ["热梗", "传播", "语言"],
    cover:
      "https://readdy.ai/api/search-image?query=colorful%20chat%20message%20bubble%20shapes%20in%20warm%20red%20and%20amber%20on%20cream%20background%2C%20minimal%20editorial%20graphic%20composition&width=800&height=500&seq=art-2026-a6&orientation=landscape",
    content: [
      {
        type: "p",
        text: "梗的产生往往很偶然，但扩散路径高度相似：小圈子造词，中间层转译，大众层抽象化。",
      },
      { type: "h2", text: "第一步：原生语境" },
      {
        type: "p",
        text: "梗最早出现在具体场景里，带着明确情绪。此时它还不能脱离出处单独使用。",
      },
      { type: "h2", text: "第二步：脱离语境" },
      {
        type: "p",
        text: "当有人把它拿来描述另一件事，梗就完成了解绑。它开始变成一种通用情绪标签，适用场景迅速扩张。",
      },
      { type: "h2", text: "第三步：被用滥" },
      {
        type: "p",
        text: "过度使用会让梗失去锋利度。等到连官方媒体都在用，它基本就进入了消退期，生命周期通常在三周左右。",
      },
      {
        type: "quote",
        text: "梗的死亡不是因为不好笑，而是因为太好用。",
      },
    ],
  },
  {
    id: "cutting-rhythm",
    title: "综艺剪辑节奏拆解：三分钟一个钩子怎么做",
    excerpt:
      "一档综艺能不能让人坐下来看完，很大程度取决于剪辑的『钩子密度』。我们数了一下热门段落的结构。",
    categorySlug: "variety",
    categoryName: "综艺名场面",
    author: "编辑部 · 阿柚",
    date: "2026-09-02",
    readTime: "5 分钟",
    hot: 6420,
    tags: ["综艺", "剪辑", "节奏"],
    cover:
      "https://readdy.ai/api/search-image?query=backstage%20corridor%20of%20a%20tv%20studio%20in%20warm%20amber%20light%20with%20equipment%20cases%2C%20cinematic%20editorial%20photography%2C%20clean%20composition&width=800&height=500&seq=art-2026-a7&orientation=landscape",
    content: [
      {
        type: "p",
        text: "把三段热门综艺片段放在一条时间轴上，会发现它们几乎都遵循同一个节奏模板。",
      },
      { type: "h2", text: "开场 15 秒：先给结果" },
      {
        type: "p",
        text: "片段开头往往先抛出一个夸张反应或悬念结果，逼观众停下来。这个手法在短视频里更常见，如今被大量用进正片。",
      },
      { type: "h2", text: "中段：情绪递进而非事件堆叠" },
      {
        type: "p",
        text: "好的剪辑不是把有趣的事排在一起，而是让情绪一层层往上走。观众记住的通常是最后的情绪高点，而不是中间发生了什么。",
      },
      { type: "h2", text: "收尾：留一个未解的问题" },
      {
        type: "p",
        text: "结束前给一个没有答案的悬念，是让人继续看下一段最有效的方式。这也是很多人说『停不下来』的原因。",
      },
    ],
  },
  {
    id: "casting-supporting-role",
    title: "选角讨论热度走高：观众在期待什么样的配角",
    excerpt:
      "最近几部剧的讨论里，配角的关注度甚至超过了主角。观众的口味正在从『谁演』转向『演得像不像』。",
    categorySlug: "screen",
    categoryName: "影视风向",
    author: "编辑部 · 顾南",
    date: "2026-09-01",
    readTime: "4 分钟",
    hot: 6010,
    tags: ["剧集", "选角", "配角"],
    cover:
      "https://readdy.ai/api/search-image?query=film%20clapperboard%20and%20script%20pages%20on%20warm%20wooden%20table%20with%20golden%20light%2C%20cinematic%20editorial%20still%20life%2C%20clean%20background&width=800&height=500&seq=art-2026-a8&orientation=landscape",
    content: [
      {
        type: "p",
        text: "一个明显的变化是，观众越来越愿意花时间讨论配角。因为配角往往承担了剧集里最具体的生活质感。",
      },
      { type: "h2", text: "从『流量』到『贴合度』" },
      {
        type: "p",
        text: "选角讨论的关键词正在变化，『像不像』出现的频率已经高于『红不红』。这代表观众更在意角色是否可信。",
      },
      { type: "h2", text: "配角撑起世界观" },
      {
        type: "p",
        text: "主角推动情节，配角搭建环境。一个恰到好处的配角，能让观众迅速相信这个故事的世界是真实存在的。",
      },
      {
        type: "quote",
        text: "观众记得住主角的名字，但往往被配角的一句台词击中。",
      },
    ],
  },
  {
    id: "choreography-three-ways",
    title: "从练习室到舞台：一段编舞的三种呈现",
    excerpt:
      "同一段编舞，练习室版、直拍版、播出版给人的感受完全不同。差别来自镜头、服装和空间。",
    categorySlug: "stage",
    categoryName: "舞台现场",
    author: "编辑部 · 小野",
    date: "2026-08-31",
    readTime: "4 分钟",
    hot: 5680,
    tags: ["编舞", "舞台", "练习室"],
    cover:
      "https://readdy.ai/api/search-image?query=dance%20rehearsal%20studio%20with%20large%20mirror%20and%20warm%20wooden%20floor%2C%20amber%20light%2C%20empty%20room%2C%20cinematic%20editorial%20photography&width=800&height=500&seq=art-2026-a9&orientation=landscape",
    content: [
      {
        type: "p",
        text: "练习室版之所以常被单独讨论，是因为它把编舞本身还给了观众，没有灯光和服装的加成。",
      },
      { type: "h2", text: "练习室版：看得最清楚" },
      {
        type: "p",
        text: "空间小、机位固定、光线均匀，动作的力度与卡点一目了然。它是判断编舞质量最直接的版本。",
      },
      { type: "h2", text: "直拍版：看得最连贯" },
      {
        type: "p",
        text: "直拍适合看个人完成度。一个人的走位是否稳定、表情是否在线，在直拍里很难藏住。",
      },
      { type: "h2", text: "播出版：看得最完整" },
      {
        type: "p",
        text: "播出版靠运镜和灯光制造氛围，代价是细节被切碎。它更像一支作品，而不是一次考核。",
      },
    ],
  },
  {
    id: "accessory-formula",
    title: "配饰比衣服更抢镜？红毯造型的细节公式",
    excerpt:
      "一个耳饰、一枚戒指，常常决定整套造型的完成度。整理了几条摄影师愿意多按快门的细节规律。",
    categorySlug: "style",
    categoryName: "红毯造型",
    author: "编辑部 · 苏黎",
    date: "2026-08-30",
    readTime: "3 分钟",
    hot: 5210,
    tags: ["配饰", "造型", "红毯"],
    cover:
      "https://readdy.ai/api/search-image?query=collection%20of%20gold%20and%20pearl%20jewelry%20accessories%20arranged%20on%20warm%20cream%20silk%20fabric%2C%20editorial%20product%20photography%2C%20soft%20shadows&width=800&height=500&seq=art-2026-a10&orientation=landscape",
    content: [
      {
        type: "p",
        text: "衣服决定第一眼，配饰决定第二眼。摄影师往往在第二眼决定多按几次快门。",
      },
      { type: "h2", text: "视觉重心只留一个" },
      {
        type: "p",
        text: "如果耳饰很大，戒指和项链就该收敛。同时亮三处，镜头里会变成一团光点，反而看不清重点。",
      },
      { type: "h2", text: "金属色和肤色要和" },
      {
        type: "p",
        text: "冷调金属适合偏冷肤色，暖调金色在暖光下更融合。这个细节决定了配饰是『长在身上』还是『浮在表面』。",
      },
      {
        type: "quote",
        text: "配饰的作用不是被看见，而是让人愿意再多看一秒。",
      },
    ],
  },
];